<template>
  <div id="app">
    
    <div class="overlay">
        <div id="spinLoading">
            <span></span>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-spinner fa-w-16 fa-spin fa-lg"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" class=""></path></svg>
        </div>
    </div>
    
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {

  },
  data: function(){
    return {
        route : 'home' ,
        class_app : 'header-iacr' , 
        window: {
            width: 0,
            height: 0
        }
    } 
  },
  mounted() {
    this.findRoute();
    this.handleResize();
    this.class_app = (this.$route.name==null)?'header_home':'';
  },
  created() {
    this.$store.commit('setEnv',process.env) ; 
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods : {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.$store.commit('setWindow',this.window) ; 
    },
    findRoute : function(){
      let uri     = window.location.pathname.split('/') ; 
      this.route = ( uri[uri.length-1].length > 2 ) ? uri[uri.length-1] : '' ;
      // console.info("this.route",this.route) ;  
    }
  }, 
  watch:{ 
      $route : function(to,from){
        if ( to.name != "home") 
          this.route = to.name ; 
        else
          this.findRoute();
      }
  }
}
</script>

<style lang="scss">

$bg_color: #0d3453 ; 

/* import common css app */
/* @import '@/csu-vue-components/assets/css/app.scss' ;*/

</style>
